import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, Coffee, DollarSign, Sun } from 'lucide-react';
export function VisionSection() {
  return <section className="py-24 bg-brown text-cream relative overflow-hidden" data-id="element-357">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-5" data-id="element-358"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center relative z-10" data-id="element-359">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-360">
          <div className="inline-flex items-center gap-2 bg-white/10 px-4 py-2 rounded-full mb-8 text-sm font-medium text-gold-light border border-white/10" data-id="element-361">
            <Calendar className="w-4 h-4" data-id="element-362" />
            <span data-id="element-363">Dentro de 7 días...</span>
          </div>

          <h2 className="text-4xl md:text-6xl font-serif font-bold mb-12 text-gold-light" data-id="element-364">
            Imagina esto...
          </h2>

          <p className="text-xl md:text-3xl leading-relaxed font-light italic opacity-90 mb-16 font-serif" data-id="element-365">
            "Despertar, revisar tu WhatsApp y ver{' '}
            <span className="text-white font-bold not-italic border-b-2 border-gold" data-id="element-366">
              tres pedidos nuevos
            </span>
            . Sin jefes gritando, sin horarios pesados, y con el orgullo de
            decirle a tu familia:{' '}
            <span className="font-bold text-white not-italic" data-id="element-367">
              Esto lo hice yo y este es mi dinero
            </span>
            ."
          </p>

          {/* Timeline */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto mb-16" data-id="element-368">
            {[{
            time: '8:00am',
            icon: <Sun className="w-5 h-5 text-gold" data-id="element-369" />,
            text: 'Revisas WhatsApp: 3 pedidos nuevos'
          }, {
            time: '10:00am',
            icon: <Coffee className="w-5 h-5 text-gold" data-id="element-370" />,
            text: 'Preparas tus productos con café'
          }, {
            time: '2:00pm',
            icon: <DollarSign className="w-5 h-5 text-gold" data-id="element-371" />,
            text: 'Recibes +$85 en Zelle'
          }].map((step, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.2
          }} className="bg-white/5 border border-gold/30 rounded-xl p-6 text-left hover:bg-white/10 transition-colors" data-id="element-372">
                <div className="flex items-center gap-2 text-gold-light font-bold text-sm mb-2" data-id="element-373">
                  {step.icon}
                  {step.time}
                </div>
                <p className="text-cream font-medium text-lg" data-id="element-374">{step.text}</p>
              </motion.div>)}
          </div>

          <div className="w-24 h-1 bg-gold mx-auto rounded-full" data-id="element-375"></div>
        </motion.div>
      </div>
    </section>;
}